export enum DrowingToolMesageKeyType {
	DiscardChanges = 'DISCARD_CHANGES',
	UploadImage = 'UPLOAD_IMAGE',
}
